import { BasicModel } from '../../basic/basic.model';
import { BcModel } from './bc.model';

export class LivraisonBcModel extends BasicModel{

    code: string = '*';
    idBcLigne: number;
    bcLine: BcModel;
    dLivraison: Date;
    qteLivre: number = 0;
    htLivre: number = 0;
    bProvis: boolean;
    dProvis: Date;
    qteLitige = 0;

}
